module.exports = __webpack_public_path__ + "static/media/leave-page.65da92f3.svg";